import React from 'react';
import { Spin as AntSpin } from 'antd';
import styled from 'styled-components';

const Wrapper = styled.div`
  .ant-spin {
    display: block;
    padding: 100px;
    text-align: center;

    &-dot-item {
      background: var(--primary-oqio-blue);
    }
  }
`;

const Spinner = () => (
  <Wrapper>
    <AntSpin size="large" />
  </Wrapper>
);

export default Spinner;
